import { default as QR } from 'qrcode';
import React, { createRef, memo, useEffect, useMemo } from 'react';
import { ThreeDotsLoader } from '../../assets/icons/ThreeDotsLoader';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './QRCode.scss';
const rootClassName = 'qrcode';

export interface QRCodeProps {
  button?: boolean;
  size: number;
  margin?: number;
  text: string;
  color?: string;
  backgroundColor?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

function QRCode(props: QRCodeProps) {
  const ref = createRef<HTMLDivElement>();
  useEffect(() => {
    QR.toString(props.text || '-', {
      type: 'svg',
      width: props.size,
      margin: props.margin,
      color: {
        dark: props.color,
        light: '#0000',
      },
    }).then((svg) => {
      if (ref.current) {
        ref.current.innerHTML = svg;
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, ref]);

  const className = useMemo(() => {
    return getMergedClassNames([rootClassName, props.button ? 'button' : '']);
  }, [props.button]);
  return (
    <div
      className={className}
      ref={ref}
      style={{
        width: props.size,
        height: props.size,
        backgroundColor: props.backgroundColor,
      }}
      onClick={props.onClick}
    >
      <ThreeDotsLoader theme='secondary' />
    </div>
  );
}

QRCode.defaultProps = {
  margin: 0,
  color: '#3fa110',
};

export default memo(QRCode);
